import React from "react";
import DashboardCards from "./DashboardCards";
import DashboardTable from "./DashboardTable";


const Dashboard = () => {
  return (
    <>
      <div className="px-4 py-4 xs:px-10 md:px-4 flex flex-col gap-4">
        <DashboardCards />
        <DashboardTable />
      </div>
    </>
  );
};

export default Dashboard;
